import { useState, useEffect } from "react";
import axios from "axios";
import {
  getAllConfiguration,
  updateAllConfiguration,
  updateConfigurations,
} from "../../api/configurationApi";
import { useAuth } from "../../context/AuthContext";
import imageCompression from "browser-image-compression";
const useConfiguration = () => {
  const { user } = useAuth();

  const [configs, setConfigs] = useState([]);
  const [changedKeys, setChangedKeys] = useState(new Set());

  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);
  const [error, setError] = useState(null);

  // Fetch configs
  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const response = await getAllConfiguration(user.barberShop);
      if (response) {
        setConfigs(response);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load configurations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, [user.barberShop]);

  // Handle input changes locally
  const handleChange = (key, value) => {
    setConfigs((prev) =>
      prev.map((c) => (c.configKey === key ? { ...c, configValue: value } : c))
    );

    setChangedKeys((prev) => new Set(prev).add(key)); // Mark as changed
  };

  const refreshConfigurations = async () => {
    var result = await updateAllConfiguration(user.barberShop);
    if (result.data?.isSuccess) {
      fetchConfigs();
    }
  };
  // Save a single config to backend
  const handleSave = async () => {
    const updatedConfigs = configs.filter((c) => changedKeys.has(c.configKey));

    try {
      var result = await updateConfigurations(updatedConfigs, user.barberShop);
    } catch (err) {
      console.error(err);
      setError("Failed to save configuration");
    } finally {
      setSavingKey(null);
    }
  };
  return {
    configs,
    loading,
    savingKey,
    error,
    handleChange,
    handleSave,
    fetchConfigs,
    refreshConfigurations,
  };
};
export default useConfiguration;
